<template>
  <!-- Main content -->
  <section class="content">
    <div class="btn-box">
      <el-form :inline="true">
        <el-form-item label="订单号：">
          <el-input v-model="orderId" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="user_id：">
          <el-input v-model="uid" placeholder="请输入user_uid"></el-input>
        </el-form-item>
        <el-form-item label="时间筛选：">
          <el-date-picker
            v-model="time"
            type="daterange"
            value-format="timestamp"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="status" placeholder="">
            <el-option
              v-for="item in statusList"
              :key="item.type"
              :label="item.name"
              :value="item.type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="seach(1)">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="exportVipOrder()"
            >数据导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table v-loading="loading" :data="orderList" border>
      <el-table-column fixed prop="order_sn" label="订单号" width="150px">
      </el-table-column>
      <el-table-column fixed label="uid" width="200">
        <template slot-scope="scope">
          {{ scope.row.user_id }}({{ scope.row.user_key }})
        </template>
      </el-table-column>
      <el-table-column label="主图">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.item_pic"
            :preview-src-list="[scope.row.item_pic]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="item_title"
        label="商品标题"
        width="250"
      ></el-table-column>
      <el-table-column prop="item_id" label="商品ID"></el-table-column>
      <el-table-column prop="pay_amount" label="付款金额"></el-table-column>
      <el-table-column
        prop="platform_commission"
        label="平台佣金"
        width="100px"
      ></el-table-column>
      <el-table-column
        prop="user_commission"
        label="用户佣金"
        width="100px"
      ></el-table-column>
      <el-table-column label="下单时间">
        <template slot-scope="scope">
          {{ scope.row.order_time | dateTime }}
        </template>
      </el-table-column>
      <el-table-column
        label="订单来源"
        prop="stat_param_text"
      ></el-table-column>
      <el-table-column label="结算时间">
        <template slot-scope="scope">
          {{ scope.row.user_settled_time | dateTime }}
        </template>
      </el-table-column>
      <el-table-column label="订单状态">
        <template slot-scope="scope">
          <span
            :class="
              scope.row.status == 1
                ? 'green'
                : scope.row.status == 3
                ? 'blue'
                : scope.row.status == 4
                ? 'warn'
                : scope.row.status == 5 ||
                  scope.row.status == 6 ||
                  scope.row.status == 7
                ? 'red'
                : ''
            "
          >
            {{ scope.row.status | status }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="商品类目" prop="category_name"></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="alterDialog(scope.row)"
            v-if="scope.row.status == 1 || scope.row.status == 2"
            >修改</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="settlement(scope.row.order_id)"
            v-if="scope.row.status == 1"
            >结算</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="修改"
      :visible.sync="dialog"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-form-item label="用户user_id">
          <el-input v-model="unionid" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="佣金">
          <el-input v-model="user_commission" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="alter">确 定</el-button>
      </div>
    </el-dialog>
    <el-pagination
      background
      layout="total, sizes,prev, pager, next,jumper"
      :total="total"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
    </el-pagination>
  </section>
  <!-- /.content -->
</template>

<script>
let common = JSON.parse(localStorage.getItem("common"));
import * as api from "@/config/api";
export default {
  name: "vipOrder",
  components: {},

  data() {
    let date = new Date().getTime();
    let start = new Date().getTime() - 86400000 * 14;
    return {
      time: [start, date],
      statusList: common.order_status_list,
      status: "",
      orderList: [],
      total: 0,
      page: 1,
      pagesize: 10,
      uid: "",
      orderId: "",
      loading: true,
      dialog: false,
      order_id: "",
      unionid: "",
      user_commission: "",
    };
  },
  watch: {},
  filters: {
    status(val) {
      let common = JSON.parse(window.localStorage.getItem("common"));
      let name = "";
      if (JSON.stringify(common.order_status_list).indexOf(val) != -1) {
        common.order_status_list.map((a, index) => {
          if (val === a.type) {
            name = a.name;
          }
        });
      }
      return name;
    },
    dateTime(val) {
      let day = new Date(Number(val) * 1000);
      if (Number(val) === 0) {
        return "";
      }
      return (
        day.getFullYear() +
        "-" +
        `${
          day.getMonth() + 1 < 10
            ? "0" + (day.getMonth() + 1)
            : day.getMonth() + 1
        }` +
        "-" +
        `${day.getDate() < 10 ? "0" + day.getDate() : day.getDate()}` +
        " " +
        `${day.getHours() < 10 ? "0" + day.getHours() : day.getHours()}` +
        ":" +
        `${day.getMinutes() < 10 ? "0" + day.getMinutes() : day.getMinutes()}` +
        ":" +
        `${day.getSeconds() < 10 ? "0" + day.getSeconds() : day.getSeconds()}`
      );
    },
  },
  mounted() {
    this.getVipOrderList();
  },
  methods: {
    settlement(id) {
      this.$confirm("请确定是否结算该订单", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api.vipOrderSettlement(
            {
              order_id: id,
            },
            (res) => {
              this.$message({
                type: "success",
                message: "结算成功!",
              });
              this.getVipOrderList();
            }
          );
        })
        .catch(() => {});
    },
    alterDialog({ order_id, user_id, user_commission }) {
      this.order_id = order_id;
      this.unionid = user_id;
      this.user_commission = user_commission;
      this.dialog = true;
    },
    alter() {
      api.alterVipOrder(
        {
          order_id: this.order_id,
          user_id: this.unionid,
          user_commission: this.user_commission,
        },
        (res) => {
          console.log(res);
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.dialog = false;
          this.seach(1);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    close() {
      this.show = false;
      this.getVipOrderList();
    },
    getVipOrderList(page, size) {
      if (this.time != null && this.time[0] === this.time[1]) {
        this.time[1] = this.time[0] + 86399999;
      }
      this.loading = true;
      api.getVipOrderList(
        {
          user_id: this.uid,
          order_sn: this.orderId,
          page: page ? page : this.page,
          pagesize: size ? size : this.pagesize,
          start_time: this.time != null ? parseInt(this.time[0] / 1000) : "",
          end_time: this.time != null ? parseInt(this.time[1] / 1000) : "",
          status: this.status,
        },
        (res) => {
          page && (this.page = page)
          this.orderList = res.data.list;
          this.total = Number(res.data.count);
          this.loading = false;
        }
      );
    },
    exportVipOrder(page, size) {
      if (this.time != null && this.time[0] === this.time[1]) {
        this.time[1] = this.time[0] + 86399999;
      }
      api.exportVipOrder(
        {
          user_id: this.uid,
          order_sn: this.orderId,
          page: page ? page : this.page,
          pagesize: size ? size : this.pagesize,
          start_time: this.time != null ? parseInt(this.time[0] / 1000) : "",
          end_time: this.time != null ? parseInt(this.time[1] / 1000) : "",
          status: this.status,
        },
        (res) => {
          console.log(res);
          window.open(location.protocol + "//" + res.data.url);
        }
      );
    },
    sizeChange(val) {
      this.pagesize = val;
      this.getVipOrderList();
    },
    currentChange(val) {
      this.page = val;
      this.getVipOrderList();
    },
    seach(page, size) {
      this.getVipOrderList(page, size);
    },
  },
};
</script>
<style scoped>
.cell {
  text-align: center;
}

.btn-box {
  text-align: left;
  margin-bottom: 20px;
}

.el-image img {
  height: 40px;
}

.el-image-viewer__canvas img {
  width: auto;
  height: auto;
}

.red {
  color: #f56c6c;
}

.blue {
  color: #409eff;
}

.green {
  color: #67c23a;
}

.warn {
  color: #e6a23c;
}
</style>